document.addEventListener('DOMContentLoaded', function () {
  productGridChanger();
  window.addEventListener('resize', debounce(productGridChanger, 200));
});

function productGridChanger() {
  const buttons = document.querySelectorAll('.mobile-view-by-wrap button');
  const gridItems = document.querySelectorAll('.collection__items--wrapper .grid__item');
  const isMobile = window.innerWidth <= 768;

  if (isMobile) {
    const storedMobileValue = sessionStorage.getItem('mobileGridValue') || '2';
    updateMobileLayout(storedMobileValue);
    setMobileActiveButton(storedMobileValue);

    buttons.forEach(button => {
      button.onclick = function () {
        const value = this.getAttribute('data-value');
        sessionStorage.setItem('mobileGridValue', value);
        updateMobileLayout(value);
        setMobileActiveButton(value);
      };
    });

    function updateMobileLayout(value) {
      gridItems.forEach(item => {
        [...item.classList].forEach(cls => {
          if (cls.startsWith('small--')) item.classList.remove(cls);
        });

        if (value === '1') item.classList.add('small--one-whole');
        else if (value === '2') item.classList.add('small--one-half');        
      });
    }
    function setMobileActiveButton(value) {
      buttons.forEach(btn => {
        btn.classList.toggle('mobile-active', btn.getAttribute('data-value') === value);
      });
    }

  } else {
    const storedDesktopValue = sessionStorage.getItem('desktopGridValue') || '4';
    updateDesktopLayout(storedDesktopValue);
    setActiveButton(storedDesktopValue);

    buttons.forEach(button => {
      button.onclick = function () {
        const value = this.getAttribute('data-value');
        sessionStorage.setItem('desktopGridValue', value);
        updateDesktopLayout(value);
        setActiveButton(value);
      };
    });

    function updateDesktopLayout(value) {
      gridItems.forEach(item => {
        [...item.classList].forEach(cls => {
          if (cls.startsWith('medium-up--')) item.classList.remove(cls);
        });

        if (value === '2') item.classList.add('medium-up--one-half');
        else if (value === '3') item.classList.add('medium-up--one-third');
        else if (value === '4') item.classList.add('medium-up--one-quarter');
      });
    }
    function setActiveButton(value) {
      buttons.forEach(btn => {
        btn.classList.toggle('active', btn.getAttribute('data-value') === value);
      });
    }
  }

}

// Optional: debounce to prevent excessive triggering on resize
function debounce(func, delay) {
  let timeout;
  return function () {
    clearTimeout(timeout);
    timeout = setTimeout(func, delay);
  };
}
